import CryptoJS from "crypto-js";
import config from "../config/config";
const KEY = CryptoJS.enc.Utf8.parse(config.SECRET_KEY);

export function encryptData(text_data) {
  return CryptoJS.AES.encrypt(text_data, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}
export function decryptData(encrypted_data) {
  return CryptoJS.AES.decrypt(encrypted_data, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
}
